export const isHidden = (el) => el.offsetParent === null;
